/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import "./index.scss";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { renderDynamicUrlFromComponentLevelState } from "../../helpers/utils/urlHelper";
import axiosInstance from "../../apiConfigs/axiosInstance";
import { RootStore, useAppSelector } from "../../store/store";

const PracticeInterviewButton = (props: any) => {
  const { showIcon, icon, sm, className, fromAA = false } = props;
  const configState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });
  const { pathname } = useLocation();
  const redirectToInterviewPractice = async () => {
    try {
      const dynamic_url = renderDynamicUrlFromComponentLevelState(configState);
      const res = await axiosInstance.post(`${dynamic_url}/redirect-to-dojoai`);
      if (res?.data) {
        window.open(res?.data?.redirect_url, "_blank");
      }
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="practice__interview__button link__section2">
      <button
        type="button"
        onClick={redirectToInterviewPractice}
        className={fromAA && `${className}`}
      >
        {showIcon && (
          <div className="image__section">
            <Icon
              icon={icon}
              className={`sidebar__iconify__icon ${sm && "sm"} `}
            />
          </div>
        )}
        Practice Interview
      </button>
    </div>
  );
};

export default PracticeInterviewButton;
